<div class="bo-page-container relative">
  <canvas
    #debugCanvas
    id="debugCanvas"
    class="z-1 absolute cursor-none will-change-transform"
    [ngClass]="appService.debugMode() ? 'visible' : 'hidden'"
  >
  </canvas>
  <canvas
    #dynamicCanvas
    id="dynamicCanvas"
    class="z-1 absolute cursor-none will-change-transform"
    [ngClass]="appService.showOverlays() ? 'visible' : 'hidden'"
  >
  </canvas>
  <canvas
    #overlayCanvas
    id="overlayCanvas"
    class="z-1 absolute cursor-none will-change-transform"
    [ngClass]="appService.showOverlays() ? 'visible' : 'hidden'"
  ></canvas>
  <div #screen id="screen" class="h-full w-full justify-center overflow-hidden">
    @if (!appService.demoMode()) {
      <video
        #recording
        id="recording"
        class="h-full w-full bg-bo-black object-cover"
        autoplay
        playsinline
        crossOrigin="anonymous"
      ></video>
    } @else {
      <video
        #video
        id="video"
        class="h-full w-full bg-bo-black object-cover"
        muted
        preload="metadata"
        autoplay="true"
        [src]="
          sceneStore.path()
            ? (appService.sampleMovie() ??
              sceneStore.path() + '/assets/sample.mp4')
            : null
        "
        type="video/mp4"
        (loadedmetadata)="swapVideoElement()"
      ></video>
    }
  </div>
  <!--   @if (appService.showUI() && simulationService.state() === 'simulation') {
    <div class="absolute bottom-6 right-6 flex gap-3">
      <button
        class="bo-button z-50 flex min-w-48 items-center justify-between gap-2 px-3"
        (click)="onFinish()"
      >
        <div class="flex flex-1 justify-center px-3">Finish</div>
        <svg-icon
          src="fa-icons/chevron-right.svg"
          class="bo-subheader !fill-bo-white"
          [svgStyle]="{ 'height.px': 20 }"
        />
      </button>
    </div>
  } -->
</div>
